<div class="comparsionPageWrap">
    <div class="trinkavsGarmmarlyBanner">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="bannerContent">
                        <h1>寻找Grammarly替代方案？</h1>
                        <p>从Grammarly高级套餐切换到Trinka，不会损失订阅费！</p>
                        <div class="bannerContentButtons try_a_free_form">
                            <!-- <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank" class="itsFreeButton">免费使用Trinka
                            </a>
                            <span class="orTrydemoButton">
                                <a [routerLink]="['/try-a-demo']">
                                    或者尝试一下演示
                                </a>
                            </span> -->
                            <form [formGroup]="compareTrinkaGrammarly" (ngSubmit)="onSubmitEmail()">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="form-group"
                                            [ngClass]="(!compareTrinkaGrammarly.get('userEmailId').valid && compareTrinkaGrammarly.get('userEmailId').dirty) || (compareTrinkaGrammarly.get('userEmailId').touched && compareTrinkaGrammarly.get('userEmailId').pristine) ? 'TextFiledError' : '' ">
                                            <mat-form-field appearance="outline">
                                                <mat-label>输入电子邮件 *</mat-label>
                                                <input id="contactUserEmail" matInput placeholder="" formControlName="userEmailId" class="form-control">
                                            </mat-form-field>
                                            <button type="submit">免费试用</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="grammarlyTestimonials">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="testimonialsContent">
                    <img src="assets/images/double_quotes_icon.png" alt="">
                    <p>这个AI语法检查工具超越了 Grammarly！我用Trinka重新检查了一些我之前用 Grammarly检查过的文件。看到来自印度的如此独特的产品，我感到非常惊喜，这绝对是一个更好的 Grammarly
                        替代品。
                    </p>
                    <h3> 放射科医生，印度</h3>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="switch_from_grammarly custom_width">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="grammarly_premium switchFromTrinka">
                    <h2>从Grammarly高级用户转到Trinka高级用户</h2>
                    <div class="HeadingSubLine"></div>
                    <p>您是否已经订阅了Grammarly高级服务，但正在寻找更好的替代？您可以轻松地将您的Grammarly高级服务余额切换到Trinka高级服务！</p>
                    <div class="sample_exmple">
                        <p>
                            <b>Grammarly高级套餐年度计划示例</b>
                        </p>
                        <p>高级套餐开始日期：2021年1月5日</p>
                        <p>高级套餐开始日期：2021年1月5日</p>
                        <p>您将获得的额外免费天数：255天</p>
                    </div>
                    <div class="how_it_work">
                        <a (click)="scroll(target)" class="itsFreeButton">使用方式</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="free_premium">
                    <div class="free_premium_border">
                        <div class="discount-label yellow">
                            <span>特别优惠</span>
                        </div>
                        <div class="free_premium_title">
                            免费高级扩展计算器
                        </div>
                        <i>使用此计算器得到您从Grammarly切换到Trinka能够获得的免费高级订阅的期限。</i>
                        <div class="free_premium_form">
                            <!-- <form> -->
                            <div class="textbox_content form-group">
                                <label>Grammarly高级套餐开始日期：</label>
                                <input placeholder="MM/DD/YY" type="date" class="form-control" (change)="premiumDateChanged($event)">
                                <label>计划类型</label>
                                <select class="custom-select" [ngModel]="grammarlySelect" (change)="planTypeChanged($event)">
                                    <option selected value="">计划类型</option>
                                    <option value="M">月度</option>
                                    <option value="Y">年度</option>
                                </select>
                            </div>
                            <!-- </form> -->
                            <p *ngIf="finalTextContent" class="form_status">如果您今天购买Trinka高级服务年度计划，您将获得
                                <span>{{diffDays}}</span> 额外天数。({{currentDate | date:'dd-MM-yyyy'}})
                            </p>
                            <!-- <h3>Example for Grammarly Premium Annual Plan</h3>
                            <p>Premium start date:  5 January 2021</p> 
                            <p>Today's date: 25 April 2021</p> 
                            <p>Addition free days you will get: 255 days</p> 
                            <h3 class="mart15">Example for Grammarly Premium Monthly Plan</h3>
                            <p>Premium start date:  5 January 2021</p> 
                            <p>Today's date: 25 January 2021</p> 
                            <p>Addition free days you will get: 20 days</p>  -->
                        </div>
                        <span class="validTextSection">*仅适用于通过信用卡/Debit卡付款</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="writing_need_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="compare_tables_discriptions">
                    <h2>Trinka与Grammarly的详细比较</h2>
                    <div class="HeadingSubLine"></div>
                    <p>下表总结了新一代AI语法和语言增强工具Trinka在高级英语语法检查、拼写检查、句法、语气和其他写作增强方面如何超越Grammarly。</p>
                </div>
                <div class="compare_tabels table-responsive">
                    <table class="table">
                        <tr>
                            <th>特征</th>
                            <th>Trinka</th>
                            <th>Grammarly</th>
                        </tr>
                        <tr>
                            <td>
                                学术风格指南
                                <b>（如APA、AMA等）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                基于学科的更正
                                <b>（医学、生命科学、工程等）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                技术拼写
                                <b>（根据学科进行拼写更正）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                技术用语
                                <b>（写作适合你的学科）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                语意模糊
                                <b>（讓你的寫作清晰而具體）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                出版准备检查
                                <b>（ 通过20 多项检查评估实现成功出版）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                自动文件编辑
                                <b>（在几分钟内自动编辑微软Word 文件）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/closeMark.svg" alt="">
                            </td>
                        </tr>

                        <tr>
                            <td>
                                正式/学术语调
                                <b>（包括口语、非正式短语动词和习语）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <span class="LimitedContent">有限
                                    <button class="tooltip_section AcademicTone" alt="僅限於少數類型的學術語氣特徵，例如縮略、第一人稱代詞和被動語態。除此之外，Trinka還涵蓋了口語和非正式短語動詞和習語。">
                                        <img src="assets/images/info.svg" alt="" style="max-width: 16px !important;">
                                    </button>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>字数缩减
                                <b>（使写作简洁有力）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <span class="LimitedContent">有限
                                    <button class="tooltip_section" alt="仅限于几种类型的简洁特征，例如复合介词和冗余。Trinka展示了如何采用名词化让表达更加简洁直接，它还同时通过单词和标点符号来减少字数。">
                                        <img src="assets/images/info.svg" alt="" style="max-width: 16px !important;">
                                    </button>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>无偏见的语言
                                <b>（包容、主动语式、无性别歧视的语言）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td >
                                <span class="LimitedContent">有限
                                    <button class="tooltip_section UnbiasedLanguage" alt="仅限于少数类型的无偏见语言特征，例如包容性语言。Trinka涵盖了这一点，并确保您的写作反映以人为本、性别中立的语言。">
                                        <img src="assets/images/info.svg" alt="" style="max-width: 16px !important;">
                                    </button>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>抄袭检测
                                <b>(对照网络、开放存取和付费出版的内容进行检查)</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td class="single-line-tootltip ">
                                <span class="LimitedContent">有限
                                    <button class="tooltip_section UnbiasedLanguage" alt="不包括付费出版的内容">
                                        <img src="assets/images/info.svg" alt="" style="max-width: 16px !important;">
                                    </button>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                一致性检查
                                <b>（破折号、拼写、数字等）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img style="max-width: 20px;" src="assets/images/checkMarks.svg" alt="">
                            </td>
                        </tr>
                        <tr>
                            <td>接受或忽略所有更改
                                <b>（一鍵接受或忽略多個建議）</b>
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                        </tr>
                        <tr>
                            <td>高级语法检查</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                        </tr>
                        <tr>
                            <td>句子结构修正</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                        </tr>
                        <tr>
                            <td>词语选择</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                        </tr>
                        <tr>
                            <td>美式/英式风格</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                        </tr>
                        <tr>
                            <td>详细说明和提示</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                        </tr>
                        <tr>
                            <td>个人词典</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                        </tr>
                        <tr>
                            <td>在线编辑</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                        </tr>
                        <tr>
                            <td>浏览器插件</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                        </tr>
                        <tr>
                            <td>微软 Word 插件</td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                            <td>
                                <img src="assets/images/checkMarks.svg" alt="">
                            </td>
                        </tr>

                    </table>
                </div>
                <div class="disclaimerContainer disclaimerContainer_table">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="disclaimercontents">
                                    <p>我们创建了这些比较图表，以帮助学生、教授、图书馆员和教育工作者就哪种参考文献生成器最适合他们的需求做出明智的决定。如果你们发现此图表中的任何错误或者遗漏，请
                                        <a href="mailto:support@trinka.ai">发送电子邮件</a>给我们，我们会改正。</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="try_trinka_Buttons">
                    <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">免费使用Trinka</a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="pricing_plan">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="pricing_plan_tables">
                    <h2>定价方案</h2>
                    <div class="HeadingSubLine"></div>
                    <p>比较所有功能并亲眼看看结果！Trinka不仅仅是普通的语法检查器，更是学术和技术写作的理想工具。</p>
                </div>
                <div class="compare_tabels table-responsive">
                    <div class="pricing_plan_details">
                        <div class="pricing_details">
                            <div class="plan_name">
                                <div class="plan_name_left">
                                    <label>Trinka
                                        <br>Free</label>
                                    <div class="pricing">
                                        <div class="price">
                                            $0
                                            <b>/ month</b>
                                        </div>
                                    </div>
                                </div>
                                <div class="plan_name_right">
                                    <img src="assets/images/trinka-logo.png" alt="" width="136">
                                </div>
                            </div>
                            <ul>
                                <li>上下文拼写检查</li>
                                <li>高级语法检查</li>
                                <li>书面语气更正</li>
                                <li>句子结构更正</li>
                                <li>增强写作影响力</li>
                                <li>自动文件编辑</li>
                                <li>技术用词的选择</li>
                                <li>选定风格指南</li>
                                <li>一致性检查</li>
                                <li>抄袭检测</li>
                                <li>引文检查器</li>
                                <li>出版准备写作
                                    <br>
                                    <small>(技术术语, 字数缩减 etc.)</small>
                                </li>
                                <li>期刊出版准备情况
                                    <br>
                                    <small>(期刊范围检查, 论文摘要 etc.)</small>
                                </li>
                            </ul>
                        </div>
                        <div class="pricing_details">
                            <div class="plan_name">
                                <div class="plan_name_left">
                                    <label>Grammarly Premium</label>
                                    <div class="pricing">
                                        <div class="price">
                                            $12
                                            <b>/ month</b>
                                        </div>
                                    </div>
                                </div>
                                <div class="plan_name_right">
                                    <img src="assets/images/grammarly-logo.png" alt="" width="150px">
                                </div>
                            </div>

                            <ul>
                                <li>拼写</li>
                                <li>语法、标点符号和流畅度</li>
                                <li>语调调整</li>
                                <li>以清晰为中心的句子重写</li>
                                <li>句子改写的例子</li>
                                <li>自动改写句子。</li>
                                <li>单词选择</li>
                                <li>其他高级建议</li>
                            </ul>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>

<div class="trinkaBetterThanOthers">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <div class="betterThenContent">
                    <h2>是什么使Trinka比Grammarly等一流的语法检查工具更胜一筹？</h2>
                    <div class="HeadingSubLine"></div>
                    <p>高级写作需要高级检查 -Trinka为您实现这一切！Trinka是基于人工智能的语法检查和语言增强工具，专为正式和技术写作而创建。Trinka具有内置的高级工具，可检查您的语法、拼写和标点符号并提高您的写作水平，帮您最大限度地提高发表机会。</p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="betterThenImg">
                    <img src="assets/images/BetterThen_img.png" alt="">
                </div>
            </div>
        </div>
    </div>
</div>
<div class="writing_need_sections">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="assets/images/subjectAreaAndDocumentType.svg" alt="">
                        <h3>学科领域和文件类型</h3>
                    </div>
                    <p>您可以自定义Trinka，让它根据您的学科领域和手稿类型提供最相关的建议。
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="assets/images/style_guide_icon.svg" alt="">
                        <h3>风格指南首选项</h3>
                    </div>
                    <p>根据流行的学术风格指南（AMA 11th，AGU 2017）定制您手稿的语法和单词选择。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="assets/images/autoFileEdit_icon.svg" alt="">
                        <h3>自动文件编辑</h3>
                    </div>
                    <p>上传您的微软Word文档，Trinka能在几分钟内完成自动编辑并且让您下载。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="assets/images/Icon_PublicationChecks.png" alt="" style="max-width: 30px;">
                        <h3>出版准备检查</h3>
                    </div>
                    <p>使用Trinka的出版准备检查，您可以通过从“期刊选择”到“道德合规”的20多项检查评估您的文档，从而增加论文被期刊录用的机会。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove paddingRightRemove">
                <div class="features_cards commingSoonTag">
                    <div class="features_cardsHeading">
                        <img src="assets/images/ConsistencyCheck_icons.png" alt="" style="max-width: 30px;">
                        <h3>一致性检查</h3>
                    </div>
                    <p>Trinka的一致性检查可以检测您写作中的 6种不一致，无论文章长度如何，您都可以进行一键修改。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingLeftRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <img src="assets/images/DownloadTrackChangesEdit_icon.png" alt="" style="max-width: 22px;">
                        <h3>下载跟踪更改文件</h3>
                    </div>
                    <p>您可以下载Trinka提供的跟踪更改文件，在编辑器中显示Trinka提供的各种更改选择。</p>
                </div>
            </div>


        </div>
    </div>
</div>
<div class="professionalAcademic">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h2>实现专业的学术和技术语法修正
                </h2>
                <div class="HeadingSubLine"></div>
                <p>Trinka人工智能能够执行3000多项语法检查、语气和风格增强、高级写作技巧，更重要的是它可以处理与学术和技术写作相关的所有学科的作品。</p>
                <div class="grammarCorrectionSlide">

                    <div class="grammarCorrectionMain">

                        <!-- <div class="sliderHeading">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="assets/images/grammarly-logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The beautiful part of this writing assistant, is one it works very fast
                                                            quickly, secondly second it doesn’t <b>requires</b>&nbsp;
                                                            <span>require</span> any effort from the writer.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="assets/images/trinka-logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The beautiful part of this writing assistant, is one it works <b>very
                                                                fast</b>&nbsp;<span>quickly,</span> secondly second it <b>doesn’t
                                                                requires</b>&nbsp;<span>does not require</span> any effort from the
                                                            writer.</p>
                                                    </div>
                                                </div>
                                            </div>
            
                                        </div>
                                    </div> -->
                        <div class="carousel slide" id="keyBenefitContentTwo" data-ride="carousel">
                            <ol class="carousel-indicators">
                                <li data-target="#keyBenefitContentTwo" data-slide-to="0" class="active"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="1"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="2"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="3"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="4"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="5"></li>
                                <li data-target="#keyBenefitContentTwo" data-slide-to="6"></li>
                            </ol>

                            <div class="carousel-inner">

                                <div class="carousel-item active">
                                    <div class="original-text">
                                        <i>原文</i>
                                        <p>Brazilian soils has low levels of phosphorus available, due to high acidity, therefore,
                                            are fundamental the application of phosphate fertilizers for high yields.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="assets/images/grammarly-logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Brazilian soils
                                                            <b>has</b>&nbsp;
                                                            <span>have</span> low
                                                            <b>levels of</b> phosphorus
                                                            <span>levels</span> available
                                                            <b>,</b> due to high acidity, therefore, are fundamental the application
                                                            of phosphate fertilizers for high yields.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="assets/images/trinka-logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Brazilian soils
                                                            <b>has</b>&nbsp;
                                                            <span>have</span> low levels of phosphorus
                                                            <b>available, due to </b>&nbsp;
                                                            <span>because of</span> high acidity,
                                                            <span>and </span>therefore, are fundamental
                                                            <span>to</span> the application of phosphate fertilizers for high yields.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>原文</i>
                                        <p>Cerebral stroke, a sudden interruption in the brain's blood supply, is a major cause
                                            of death and affect annually approximately 795,000.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="assets/images/grammarly-logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Cerebral stroke, a sudden interruption in the brain's blood supply,
                                                            is a major cause of death and
                                                            <b>affect</b>&nbsp;
                                                            <span>affects</span>&nbsp;annually approximately 795,000.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="assets/images/trinka-logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Cerebral stroke, a sudden interruption in the brain's blood supply,
                                                            is a major cause of death and
                                                            <b>affect annually </b>&nbsp;
                                                            <span>annually affects </span> approximately 795,000.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>原文</i>
                                        <p>The depleted proteins were finally digested by trypsin at a protein/trypsin ratio
                                            (w/w) of 50:1 at 37°C for overnight.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="assets/images/grammarly-logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The depleted proteins were finally digested by trypsin at a protein/trypsin
                                                            ratio (w/w) of 50:1 at 37°C for overnight.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="assets/images/trinka-logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The depleted proteins were finally digested
                                                            <b>by</b>&nbsp;
                                                            <span>with</span> trypsin at a protein/trypsin ratio (w/w) of 50:1
                                                            at 37°C
                                                            <b>for</b> overnight.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>原文</i>
                                        <p>Belladonna leaves as well as all other studied leaves contains two distinct phosphatase
                                            fraction belonging to types II and III.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="assets/images/grammarly-logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Belladonna leaves, as well as all other studied leaves
                                                            <span>,</span>
                                                            <b>contains</b>
                                                            <span>contain</span>
                                                            &nbsp;two distinct phosphatase
                                                            <b>fraction</b>
                                                            <span>fractions</span> belonging to types II and III. </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="assets/images/trinka-logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>Belladonna leaves
                                                            <b>as well as all</b>&nbsp;
                                                            <span>and </span> other
                                                            <b>studied</b> leaves
                                                            <span>being studied </span>
                                                            <b>contains</b>
                                                            <span>contain</span>&nbsp;two distinct phosphatase
                                                            <b>fraction</b>
                                                            <span>fractions </span>belonging to types II and III.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>原文</i>
                                        <p>He sees signs of long term starvation, worse even than what he saw in Arkansas.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="assets/images/grammarly-logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>He sees signs of
                                                            <span>long term</span>
                                                            <b>long-term</b> starvation, worse even than what he saw in Arkansas.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="assets/images/trinka-logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>He sees signs of
                                                            <span>long term</span>
                                                            <b>long-term</b> starvation,
                                                            <span>even</span> worse
                                                            <b>even</b> than what he saw in Arkansas.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>原文</i>
                                        <p>This kind of political torn-foolery has to a considerable extend prevented our movies
                                            from examining the actual problems of success.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="assets/images/grammarly-logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>This kind of political torn-foolery has to a considerable extend
                                                            prevented our movies from examining the actual problems of success.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="assets/images/trinka-logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>
                                                            <b>This kind of</b>
                                                            <span>Such</span> political
                                                            <b>torn-foolery</b>
                                                            <span>tomfoolery</span> has to a considerable
                                                            <b>extend</b>
                                                            <span>extent</span> prevented our movies from examining the actual
                                                            problems of success.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel-item">
                                    <div class="original-text">
                                        <i>原文</i>
                                        <p>The results shows 234 differently expressed proteins (DEP) between GBM to normal
                                            brain tissues.</p>
                                    </div>
                                    <div class="sliderContent sliderHeading">
                                        <div class="row">
                                            <div class="col-lg-6 paddingRightNone">
                                                <div class="sliderLeftSideHeading">
                                                    <div class="grammerlyLogo">
                                                        <img src="assets/images/grammarly-logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The results
                                                            <b>shows</b>
                                                            <span>show</span> 234 differently expressed proteins (DEP) between
                                                            GBM to normal brain tissues.</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-6">
                                                <div class="sliderRightSideHeading">
                                                    <div class="trinkaLogo">
                                                        <img src="assets/images/trinka-logo.png" alt="">
                                                    </div>
                                                    <div class="trinkaCorrections">
                                                        <p>The results
                                                            <b>shows</b>
                                                            <span>show</span> 234
                                                            <b>differently</b>
                                                            <span>differentially</span> expressed proteins (
                                                            <b>DEP</b>
                                                            <span>DEPs</span>) between GBM
                                                            <b>to</b>
                                                            <span>and</span>&nbsp;normal brain
                                                            <b>tissues</b>
                                                            <span>tissue</span>.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="compare_top_tools">
    <div class="container">
        <div class="row">
            <div class="col-lg-5">
                <div class="top_tools_image">
                    <img src="assets/images/top_tools_compare.png" alt="">
                </div>
            </div>
            <div class="col-lg-7">
                <div class="top_tools_text_contents">
                    <div class="howItWorkHeading lineWhiteColor">
                        <h3>Trinka与领先的语法检查工具之间的对比</h3>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <p>与领先的语法工具相比，Trinka作为真正的 Grammarly 替代品是如何脱颖而出的？ 我们使用Grammarly Premium和LanguageTool对来自五个学术领域的5,778个单词进行了测试，涵盖了那些对于正式和技术写作都至关重要的内容，包括更正的准确性、风格指南偏好、简洁性和基于上下文文意的拼写检查。如需查看详细比较结果，请查阅我们的白皮书。</p>
                    <a [routerLink]="['/trinka-vs-grammarly-vs-language-tool']">
                        下载白皮书
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="meetTrinka_sections">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="meetTrinka_heading">
                    <h2>高级写作需要高级检查，快来认识Trinka吧！</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <div class="meetTrinkaCard">
                    <div class="meetTrinka_img">
                        <img src="assets/images/GoBeyondGrammar&Spelling.svg" alt="">
                    </div>
                    <h3>不只是语法和拼写</h3>
                    <p>Trinka不仅仅是下一代语法检查工具，它还是您的个人写作助手，可以发现其他工具无法检测到的棘手学术写作错误。</p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="meetTrinkaCard unmatched_sections">
                    <div class="meetTrinka_img">

                        <img src="assets/images/UnmatchedWritingEnhancements.svg" alt="">
                    </div>
                    <h3>无与伦比的写作增强功能</h3>
                    <p>Trinka可以根据学术出版标准来提高您文章的语调，表达和措辞。</p>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="meetTrinkaCard learnAndHelps">
                    <div class="meetTrinka_img">
                        <img src="assets/images/Learns&HelpsYou.svg" alt="">
                    </div>
                    <h3>帮助您成为更好的作者</h3>
                    <p>Trinka提供深入的建议、解释和写作技巧，以帮助您进一步学习和提高写作水平。</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="meetTrinka_sections switchToTrinka padt0" #target>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="meetTrinka_heading">
                    <h2>从Grammarly高级用户转到Trinka高级用户</h2>
                    <div class="HeadingSubLine"></div>
                    <p>您是否已经订阅了Grammarly高级服务，但正在寻找更好的替代？您可以轻松地将您的Grammarly高级服务余额切换到Trinka高级服务！</p>
                    <p>立即轉換到Trinka，獲得高級語法更正和許多其他專為學術和技術寫作設計的功能。</p>
                    <p>3個簡單步驟立即完成</p>
                </div>
            </div>
        </div>
        <div class="key_takewaye_sections">
            <h2>如何进行？</h2>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="takeaways_cards">
                        <div class="card_overlay"></div>
                        <div class="cards_headers">
                            <p>1</p>
                        </div>
                        <div class="need_cards_body">
                            <p>单击
                                <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">免费注册</a>以创建您的账户，您将能够访问学术和技术写作的一系列专有功能。</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="takeaways_cards">
                        <div class="card_overlay"></div>
                        <div class="cards_headers">
                            <p>2</p>
                        </div>
                        <div class="need_cards_body">
                            <p>选择升级以订阅Trinka高级服务，选择包年套餐并付款。</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="takeaways_cards">
                        <div class="card_overlay"></div>
                        <div class="cards_headers">
                            <p>3</p>
                        </div>
                        <div class="need_cards_body">
                            <p>发送邮件到
                                <a href="mailto:support@trinka.ai">support@trinka.ai</a>告知您的Grammarly高级账号信息，将您的Grammarly高级服务余额转换为Trinka高级服务。</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <p class="disclaimer-txt"><strong>免责声明:</strong> 一个订单只能使用一张优惠券、折扣、报价或促销。</p>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="ready_to_levelUp">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="level_up_heading">
                    <h3>使用Trinka开始更好地写作。</h3>
                    <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">
                        <!-- <i class="fa fa-sign-in"></i> -->
                        <span>免费注册！</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="other_comparision">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Trinka vs. Ginger</h3>
                    </div>
                    <p>使用Trinka，在文法和拼写检查之外改进写作。</p>
                    <a [routerLink]="['/trinka-vs-ginger']">阅读更多
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Trinka vs. LanguageTool</h3>
                    </div>
                    <p>使用Trinka确保整体语言增强。</p>
                    <a [routerLink]="['/trinka-vs-languagetool']">阅读更多
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 paddingRightRemove">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Trinka vs. Writefull</h3>
                    </div>
                    <p>使用Trinka更好地与学术写作惯例和最佳实践融合。</p>
                    <a [routerLink]="['/trinka-vs-writefull']">阅读更多
                        <i class="fa fa-arrow-right"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="disclaimerContainer">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="disclaimercontents">
                    <p>
                        <span>免责声明：</span> 上述所有产品和公司名称均为其各自所有者的商标™或注册®商标，使用它们并不意味着与它们有任何从属关系或得到它们的许可。请注意，此处提到的所有比较都是根据产品手册/网站上提供的产品信息以及2021年9月15日在相似条件下的实际测试结果。如有任何疑问，请通过
                        <a href="mailto:support@trinka.ai">support@trinka.ai</a>与我们联系。
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>